import { PauseIcon, PlayIcon } from "@phosphor-icons/react/ssr";

import AuthorInfo from "./AuthorInfo";
import { cn } from "~/lib/utils";
import { type VideoTopTestimonialV3, VideoTrackingConfig } from "./data";
import VideoPlayer from "~/componentsDS/VideoPlayer";
import { useVideoTestimonial } from "./useVideoTestimonial";

type VideoTopSlideProps = {
    testimonial: VideoTopTestimonialV3;
    trackingConfig?: VideoTrackingConfig;
    className?: string;
};

const VideoTopSlide = ({ testimonial, trackingConfig, className }: VideoTopSlideProps) => {
    const { poster, mp4, hls, author, text, smallText } = testimonial;

    const { videoRef, videoStarted, onClick, onVideoPlay, onVideoPause } = useVideoTestimonial(
        { mp4, author, text },
        trackingConfig,
    );

    return (
        <div
            className={cn(
                "h-[514px] bg-[#E9EDF7] rounded-3xl overflow-hidden flex flex-col p-4 md:p-6",
                className
            )}
        >
            <div className="group vsl-player-sm-2 rounded-3xl overflow-hidden w-full relative mb-4 hover:scale-105 duration-500">
                <VideoPlayer
                    ref={videoRef}
                    mp4={mp4}
                    hls={hls}
                    width="352"
                    height="287"
                    poster={poster}
                    title={author}
                    controlsList="nofullscreen"
                    preload="none"
                    playsInline
                    onClick={onClick}
                    onPlay={onVideoPlay}
                    onPause={onVideoPause}
                    className={cn("nofullscreen w-full aspect-[352/287] object-cover object-top bg-trueBlack", testimonial.videoClassName)}
                />

                <div className="absolute inset-0 bg-trueBlack/20 pointer-events-none"></div>

                <button className={cn(
                    "w-14 h-14 flex items-center justify-center border-2 border-pureWhite/25 bg-pureWhite/5 backdrop-blur-md rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                    videoStarted ? "opacity-0 group-hover:animate-[fade-out_2s_forwards]" : "",
                )} onClick={onClick}>
                    {videoStarted ? <PauseIcon weight="fill" size={28} fill="white" /> : <PlayIcon weight="fill" size={28} fill="white" /> }
                </button>
            </div>

            <p className={cn("relative font-suisseBP tracking-[-0.01em] text-primary500 mb-auto", smallText ? "text-[20px] leading-[1.4] font-normal max-lg:tracking-[-0.01em]" : "text-[32px] leading-[1.1] font-light")}>
                <span className="absolute -translate-x-full">&ldquo;</span>
                {text}&rdquo;
            </p>

            <AuthorInfo author={author} />
        </div>
    );
};

export default VideoTopSlide;
